import { NavLink, useLocation } from "react-router-dom";

export function Navigation() {
    const loc = useLocation();

    return (
        <nav>
            <NavLink
                to="/dashboard"
                className={({ isActive }) =>
                    isActive || loc.pathname === "/" ? "active" : undefined
                }
            >
                <span>📊</span> Dashboard
            </NavLink>
            <NavLink
                to="/autocall"
                className={({ isActive }) => (isActive ? "active" : undefined)}
            >
                <span>📞</span> Auto Calls
            </NavLink>
            <NavLink
                to="/transfer-queue"
                className={({ isActive }) => (isActive ? "active" : undefined)}
            >
                <span>🔄</span> Transfer Queue
            </NavLink>
            <NavLink
                to="/scheduled"
                className={({ isActive }) => (isActive ? "active" : undefined)}
            >
                <span>🕐</span> Scheduled
            </NavLink>
            <NavLink
                to="/posted-order"
                className={({ isActive }) => (isActive ? "active" : undefined)}
            >
                <span>📤</span> Posted Orders
            </NavLink>
            <NavLink
                to="/call-audit"
                className={({ isActive }) => (isActive ? "active" : undefined)}
            >
                <span>🧾</span> Call Audit
            </NavLink>
        </nav>
    );
}
